import type { EnvironmentContext } from '@ori/environment';

import { getCountryCode } from './getCountryCode';

export const memberBenefitsPath = '/member-benefits';
export const vipCustomerBenefitsPath = '/vip-customer-benefits';
export const comparisonPagePath = '/comparison-page';
export const businessOpportunityPath = '/business-opportunity';
const oldRegistrationPaths = [memberBenefitsPath, vipCustomerBenefitsPath, comparisonPagePath, businessOpportunityPath];
export const ssoRegisterPath = '/ssoidentity/register';

export interface GetHomeCountryUrlParams extends Pick<EnvironmentContext, 'environment'> {
  store?: string | undefined;
}

/**
 * Returns URL to the home country Oriflame.
 */
export const getHomeCountryUrl = ({ environment = 'live', store }: GetHomeCountryUrlParams): string => {
  const countryCode = getCountryCode();
  const pathname = window.location.pathname
    // remove /[a-z]{2} from the pathname if it is on the first position
    .replace(/^\/[a-z]{2}\//, '/')
    // replace old registration paths with new registration path
    .replace(new RegExp(`^(${oldRegistrationPaths.join('|')})`), ssoRegisterPath);

  const homeCountryUrl = new URL(
    environment === 'live'
      ? `https://${countryCode}.oriflame.com${pathname}`
      : `https://${countryCode}-${environment}.oriflame.com${pathname}`,
  );
  homeCountryUrl.search = window.location.search;
  homeCountryUrl.hash = window.location.hash;
  if (store) {
    // set store query param in URL
    homeCountryUrl.searchParams.set('store', store);
  }

  return homeCountryUrl.toString();
};
